import { render } from "./newUserRoleForm.vue?vue&type=template&id=08bb646c&scoped=true"
import script from "./newUserRoleForm.vue?vue&type=script&lang=js"
export * from "./newUserRoleForm.vue?vue&type=script&lang=js"

import "./newUserRoleForm.vue?vue&type=style&index=0&id=08bb646c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bb646c"]])

export default __exports__